import { render, staticRenderFns } from "./searchDetail.vue?vue&type=template&id=be41dd9e&scoped=true"
import script from "./searchDetail.vue?vue&type=script&lang=js"
export * from "./searchDetail.vue?vue&type=script&lang=js"
import style0 from "./searchDetail.vue?vue&type=style&index=0&id=be41dd9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be41dd9e",
  null
  
)

export default component.exports